import { useSelector } from "react-redux";
import AccordionAction from "@common/redux/actions/AccordionAction";

const useAccordion = () => {
  const data = useSelector((state) => AccordionAction.getStatePath(state));
  const setState = (data) => AccordionAction.dispatch(data);

  const setAccordionIndex = (indices) =>
    setState({ activeAccordionIndex: indices });

  return { ...data, setAccordionIndex };
};

export default useAccordion;
